import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import AppIcon from 'components/common/AppIcon/AppIcon';
import ContainerHeader from 'components/common/ContainerHeader';

import {colors, scrollStyles} from 'styles/shared';

const SummaryTabContainer = styled.div`
  margin-top: 3rem;
  height: 53rem;
  overflow-y: auto;
  padding-right: 2rem;
  ${scrollStyles};
`;

const RequirementsRow = styled.div`
  display: flex;
  justify-content: space-around;
  margin-bottom: 2rem;
`;

const RequirementsItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const RequirementsTitle = styled.div`
  margin-top: 0.5rem;
  font-size: 1.8rem;
  font-weight: bold;
  text-transform: capitalize;
`;

const RequirementsSubtitle = styled.div`
  font-size: 1.4rem;
  color: ${colors.darkBlue_main};
  text-transform: capitalize;
`;

const RiskLevelContainer = styled.div`
  background: ${props => props.background};
  font-weight: bold;
  font-size: 1.7rem;
  line-height: 2.7rem;
  color: ${props => props.color};
  padding: 1rem;
  border-radius: 1.5rem;
  margin-bottom: 2rem;
  text-align: center;
  width: 100%;
`;

const ItemRow = styled.div`
  font-size: 1.7rem;
  line-height: 2.7rem;
  color: ${colors.darkBlue_main};
`;

const DateContainer = styled.div`
  font-weight: bold;
  font-size: 1.7rem;
  line-height: 2.7rem;
  color: ${colors.darkBlue_main};
  margin: 1rem 0;
`;

const NotesContainer = styled.div`
  font-size: 1.8rem;
  line-height: 2.2rem;
  color: ${colors.darkBlue_main};
  margin: 1rem 0;
`;

const REQUIRED = 'required';

const RISK_STATUS_GREEN = 'green';
const RISK_STATUS_AMBER = 'amber';
const RISK_STATUS_RED = 'red';

SummaryTab.propTypes = {
  data: PropTypes.object.isRequired
};

function SummaryTab({data}) {
  function getRiskLevelBackground(riskLevel) {
    let riskLevelColor = '';

    switch (riskLevel) {
      case RISK_STATUS_RED:
        riskLevelColor = colors.darkBlue_darker;
        break;

      case RISK_STATUS_AMBER:
        riskLevelColor = colors.yellow_dark;
        break;

      case RISK_STATUS_GREEN:
        riskLevelColor = colors.green_dark;
        break;

      default:
        break;
    }

    return riskLevelColor;
  }

  function renderRequirementsItem(requirements, field) {
    const value = requirements?.[field];

    let isRequired = value === REQUIRED;

    return (
      <RequirementsItem>
        <AppIcon name={field} disabled={!isRequired} />
        <RequirementsTitle>{field}</RequirementsTitle>
        <RequirementsSubtitle>({value})</RequirementsSubtitle>
      </RequirementsItem>
    );
  }

  function render() {
    const advice = data?.advice;

    const riskLevel = advice?.riskLevel;

    let riskLevelColor = riskLevel === RISK_STATUS_RED ? 'white' : colors.darkBlue_darker;
    let riskLevelBackground = getRiskLevelBackground(riskLevel);

    const requirements = advice?.requirements;

    return (
      <SummaryTabContainer>
        <RiskLevelContainer color={riskLevelColor} background={riskLevelBackground}>
          {advice.riskLevelRecomandation}
        </RiskLevelContainer>

        <RequirementsRow>
          {renderRequirementsItem(requirements, 'masks')}
          {renderRequirementsItem(requirements, 'quarantine')}
          {renderRequirementsItem(requirements, 'tests')}
        </RequirementsRow>

        <ItemRow>From: {data.from}</ItemRow>
        <ItemRow>To: {data.to}</ItemRow>
        <DateContainer>{data.date}</DateContainer>

        <ContainerHeader>Description</ContainerHeader>
        <NotesContainer>{data.description}</NotesContainer>

        <ContainerHeader>Recommendation</ContainerHeader>
        <NotesContainer>{data.recommendation}</NotesContainer>
      </SummaryTabContainer>
    );
  }

  return render();
}

export default SummaryTab;
